var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFair = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 12.491,
    viewBox: "0 0 14 12.491",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(341.132 -267.691)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-327.6,274.53a6.921,6.921,0,0,0-1.51-2.357l-.669.576a6.066,6.066,0,0,1,1.774,4.3,6.153,6.153,0,0,1-.513,2.451,5.762,5.762,0,0,1-.708,1.214h-9.812a6.317,6.317,0,0,1-.708-1.214,6.154,6.154,0,0,1-.513-2.451,6.2,6.2,0,0,1,1.657-4.194l-.662-.568a6.961,6.961,0,0,0-1.4,2.241,6.976,6.976,0,0,0-.467,2.521,6.765,6.765,0,0,0,.584,2.8,2.449,2.449,0,0,0,.155.319.585.585,0,0,0,.078.156,1.743,1.743,0,0,0,.132.233,1.606,1.606,0,0,0,.179.288,5,5,0,0,0,.411.584l.132.164h10.653l.132-.164a6.332,6.332,0,0,0,.56-.809c.068-.117.132-.233.194-.35.068-.137.137-.28.205-.42a6.786,6.786,0,0,0,.584-2.8A7,7,0,0,0-327.6,274.53Z",
    transform: "translate(0 -1.415)",
    fill: "#afafaf"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-328.812,268.97l-1.054,1.7-.144-.1a5.661,5.661,0,0,0-6.268.123l-.151.1-.123-.2c-.281-.452-.582-.931-.862-1.362l-.1-.137.144-.1a7.714,7.714,0,0,1,8.41-.13Z",
    transform: "translate(-1.144)",
    fill: "#ffbc3d"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-331.959,272.255l-.049,4.131a1.3,1.3,0,0,0-.651.556,1.324,1.324,0,0,0,.471,1.811,1.324,1.324,0,0,0,1.811-.471,1.324,1.324,0,0,0-.471-1.811,1.313,1.313,0,0,0-.284-.125l.051-4.08Zm.815,5.559a.437.437,0,0,1-.6.159h0a.437.437,0,0,1-.16-.6.437.437,0,0,1,.6-.16h0a.436.436,0,0,1,.16.6Z",
    transform: "translate(-2.617 -1.441)",
    fill: "#afafaf"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFair);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/fair.734d46911d41fc08f0a28b661131461d.svg";